import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Clock, Shield } from "lucide-react";

interface SessionWarningDialogProps {
  open: boolean;
  secondsLeft: number;
  onExtend: () => void;
}

export const SessionWarningDialog = ({
  open,
  secondsLeft,
  onExtend,
}: SessionWarningDialogProps) => {
  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    if (mins > 0) {
      return `${mins} minute${mins > 1 ? "s" : ""} et ${secs} seconde${secs > 1 ? "s" : ""}`;
    }
    return `${secs} seconde${secs > 1 ? "s" : ""}`;
  };

  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-[hsl(var(--warning)/.2)] rounded-full">
              <Clock className="h-6 w-6 text-[hsl(var(--warning))]" />
            </div>
            <AlertDialogTitle className="text-xl">
              Session sur le point d'expirer
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription className="space-y-3">
            <div className="flex items-start gap-2 p-3 bg-[hsl(var(--warning)/.1)] rounded-lg border border-[hsl(var(--warning)/.3)]">
              <Shield className="h-5 w-5 text-[hsl(var(--warning))] mt-0.5 flex-shrink-0" />
              <p className="text-sm text-foreground">
                Votre session va expirer pour des raisons de sécurité dans{" "}
                <span className="font-bold">{formatTime(secondsLeft)}</span>.
              </p>
            </div>
            <p className="text-sm text-muted-foreground">
              Pour protéger vos données personnelles, nous déconnectons
              automatiquement les utilisateurs inactifs. Cliquez sur le bouton
              ci-dessous pour rester connecté.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onExtend} className="w-full">
            Rester connecté
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
